import type { IAppDetailsAppData, IPlatform } from '../common-types';
import { platformNameConverter } from '../common-utilities';
import { styled } from '@mui/material';
import { FeaturesList } from '../AppDetails/FeaturesList';

export type PlatformGeneralFeaturesProps = IPlatform & {
  app: IAppDetailsAppData;
  translatedText: {
    platformGeneralFeaturesHeading: string;
  };
};

const Container = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(3)} 0 ${theme.spacing(5)}`,
}));

/**
 * PlatformGeneralFeatures from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param translatedText is required, this is the text that as already been translated by the consumer of this component.
 */

export const PlatformGeneralFeatures = ({
  platformName,
  app,
  translatedText,
  ...props
}: PlatformGeneralFeaturesProps) => {
  const { platforms } = app ?? {};
  const relevantPlatform = platforms?.find(
    (p) => platformNameConverter(p.platformName) === platformName
  );
  const generalFeatures = relevantPlatform?.generalFeatures;

  return (
    <>
      {generalFeatures && generalFeatures.length > 0 && (
        <Container {...props}>
          <FeaturesList
            title={translatedText?.platformGeneralFeaturesHeading}
            items={generalFeatures}
          />
        </Container>
      )}
    </>
  );
};
